export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img5-c39f8c0bc45d9736e3c7049ec55996aa.png";